import React from 'react';
import { Divider, Grid, Title } from '@mantine/core';
import GlobalLoader from '@/components/common/layout/GlobalLoader/GlobalLoader';
import CustomTabs from '@/components/common/shared/CustomTabs/CustomTabs';
import ChartWrapperDashboard from '@/components/dashboard/charts/ChartWrapper';
import WalletDashboard from '@/components/dashboard/walletDashboard/WalletDashboard';
import useFetchPricingContracts from '@/components/prices-and-charts/useFetchPricingContracts';
import { WalletCategory } from '@/types/Wallet';
import { CATEGORIES, TAB_LABELS, WALLET_CATEGORIES, WALLET_TAB_LABELS } from '@/utils/chartsConfig';
import styles from "@/pages/index.module.css";

const Dashboard = () => {
  const { contractsStructure, loading, error } = useFetchPricingContracts();

  return (
    <GlobalLoader isLoading={loading} isError={!!error} errorMessage={error}>
      <Grid>
        <Grid.Col>
          <CustomTabs
            categories={WALLET_CATEGORIES}
            labels={WALLET_TAB_LABELS}
            renderPanel={(category: WalletCategory) => <WalletDashboard category={category} />}
            variant="primary"
          />
        </Grid.Col>
        <Grid.Col>
          <div>
            <Divider className={styles.divider} />
            <Title order={4} style={{ marginTop: '1rem' }}>Notowania TGE</Title>
          </div>
          <CustomTabs
            categories={CATEGORIES}
            labels={TAB_LABELS}
            renderPanel={(category) => (
              <ChartWrapperDashboard categoryData={contractsStructure?.[category]} />
            )}
            variant="secondary"
          />
        </Grid.Col>
      </Grid>
    </GlobalLoader>
  );
};

export default Dashboard;
